import { AxiosInstance } from 'axios'

import { toGsResponse } from '../../goodstack'

import { GetGivingProfileResponse } from './getGivingProfile.types'

export const getGivingProfile = async (client: AxiosInstance) =>
  client
    .get<GetGivingProfileResponse>('v1/account/giving/profile', {
      withCredentials: true,
      validateStatus: (code: number) => code === 200 || code === 404
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r.data : undefined))
    .catch(() => undefined)
